let includeOpenButton = document.querySelector('[data-toggle-include]');
let includeCloseButton = document.querySelector('[data-include-close]');
let variants = document.querySelectorAll('.clearRoutine__variant');

// Function to handle click events on the body
function bodyClickHandler(event) {
  // Check if the clicked element is not includeOpenButton, includeCloseButton, or inside the .clearRoutine__sidebar
  if (!event.target.closest('[data-toggle-include]') && !event.target.closest('[data-include-close]') && !event.target.closest('.clearRoutine__sidebar')) {
    // Remove the 'show__include' class from the body
    document.body.classList.remove('show__include');
  }
}

// Add event listener to the body to listen for click events
document.body.addEventListener('click', bodyClickHandler);

if(includeOpenButton != null){
  includeOpenButton.addEventListener('click', function(e){
    e.preventDefault();
    document.body.classList.add('show__include');
  });
}

if(includeCloseButton != null){
  includeCloseButton.addEventListener('click', function(e){
    e.preventDefault();
    document.body.classList.remove('show__include');
  });
}

if(variants != null){
  variants.forEach(variant => {
    variant.addEventListener('click', function(){
      let variantValueInput = document.getElementById('variantID');
      variants.forEach(otherVariant => {
        otherVariant.classList.remove('active__variant');
      });
      variant.classList.add('active__variant');
      let selectedVariant = variant.querySelector('label').getAttribute('data-variant-id');
      variantValueInput.value = selectedVariant;

      var check_popup = document.querySelector(".subscription-loop-wrapper .product-variants-wrapper");
      if(check_popup != null && check_popup.classList.contains('open')){
        document.querySelector(".variant-subs-wrapper .variants-dropdown-mobile").classList.add('variant-selected');
        var variant__title = this.querySelector('.clearRoutine__variant-title').innerHTML;
        document.querySelector(".variant-subs-wrapper .selected-variant").innerHTML = variant__title;
        document.querySelector(".variant-subs-wrapper .variants-dropdown-mobile").classList.remove('active');
        document.querySelector(".variant-subs-wrapper").classList.remove('dropdown-open');
        document.querySelector(".variant-subs-wrapper .product-variants-wrapper").classList.remove('open');
      }
    });
  });
}

// Mobile dropdown variants

var mobile_dropdown = document.querySelector(".subscription-loop-wrapper .variants-dropdown-mobile")
if(mobile_dropdown != null){
  mobile_dropdown.addEventListener("click", function () {       
    var variant_wrapper = this.nextElementSibling;
    this.classList.toggle('active');
    variant_wrapper.classList.toggle('open');
    if(this.closest('.variant-subs-wrapper') != null){
      this.closest('.variant-subs-wrapper').classList.toggle('dropdown-open');
    }
  })
}

document.addEventListener('DOMContentLoaded', () => {
  const variantButtons = document.querySelectorAll('.coll-bundle-clearRoutine__variant');
  const ctaButton = document.querySelector('.product-buy-buttons--cta');
  const ctaText = document.querySelector('.product-buy-buttons--cta-text');

  variantButtons.forEach(variantBtn => {
    variantBtn.addEventListener('click', () => {
      ctaButton.classList.add('highlight');
      ctaText.classList.add('highlight');
    });
  });
});